import { Observable, Subscription, of, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, filter, map, catchError } from 'rxjs/operators';
import {
  getObjectKeys,
  groupDataBySection,
  shouldShowSectionIcon,
  collapseAllDependents,
  isTruncated,
  getTruncated,
  base64ToBlob
  } from './mapping-result-common';
import {
  AfterViewInit,
  AfterViewChecked,
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  ElementRef,
  inject,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MappingResultFeedbackComponent } from '../_dialog/mapping-result/mapping-result-feedback/mapping-result-feedback.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LayoutService } from '../_services/layout.service';
import { MappingResultService } from '../_services/mapping-result.service';
import { CommonModule } from '@angular/common';
import { ConfirmationValidationComponent } from '../_dialog/mapping-result/confirmation-validation/confirmation-validation.component';
import { MarkdownModule } from 'ngx-markdown';
import { MarkedHtmlPipe } from './marked-html.pipe';
import { AiInsightsComponent } from '../_dialog/mapping-result/ai-insights/ai-insights.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MotifModule } from '@ey-xd/ng-motif';
import { LoanAiService } from '../loanAiService';
import { ChatbotDialogComponent } from '../_dialog/chatbot-dialog/chatbot-dialog.component';
import { ProfileService } from '../_services/profile.service';
import { ConfirmStatusDialogComponent } from '../_dialog/mapping-result/confirmation-actions-modal/confirm-status-dialog.component';
import { FeedbackCategoryModalComponent } from '../_dialog/mapping-result/feedback-category-modal/feedback-category-modal.component';
import { CommentModalComponent } from '../_dialog/mapping-result/comment-modal/comment-modal.component';
import { AnswerModalComponent } from '../_dialog/answer-modal-show-more-modal/answer-modal.component';

import { MappingResultHistoryModalComponent } from '../_dialog/mapping-result-history-modal/mapping-result-history-modal.component';
import { CustomTooltipComponent } from '../_shared/custom-tooltip/custom-tooltip.component';
import { ValidationSourceModalComponent } from '../_dialog/mapping-result/validation-source-modal/validation-source-modal.component';
import { DependentValueModalComponent } from '../_dialog/mapping-result/dependent-value-modal/dependent-value-modal.component';

export interface MapResult {
  attribute_name: string;
  value: string;
  validation: boolean;
  doc_label: string;
  page_no: string;
  id: string;
  feedback?: string;
}
const ELEMENT_DATA: MapResult[] = [];

@Component({
  selector: 'app-mapping-result',
  imports: [
    MatTooltipModule,
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTableModule,
    CommonModule,
    MatSortModule,
    PdfJsViewerModule,
    MatIcon,
    MatBadgeModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MotifModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MarkdownModule,
    MarkedHtmlPipe,
    CustomTooltipComponent
  ],
  standalone: true,
  templateUrl: './mapping-result.component.html',
  styleUrls: ['./mapping-result.component.scss'],
})
export class MappingResultComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  documentList: any[] = [];
  selectedDocumentIndex: number = 0;
  selectedDocumentId: string | null = null;
  classifiedDocuments: { [classification: string]: any[] } = {};
  expandedClassifications: { [classification: string]: boolean } = {};
  classifiedGroupKeys: string[] = [];
  currentGroupIndex: number = 0;
  showDocumentListLoading: boolean = false;
  expandedSectionIndex: number = -1;
  updatedRows: { [key: string]: any } = {};
  isHistoryModalOpen: boolean = false;
  selectedHistory: Array<{ date: string; value: string }> = [];
  commentCounts: { [data_element_name: string]: number } = {};
  IsLoader: boolean = false;
  public isCurrentPdf = false;
  showValidationModal = false;
  validationModalElement: any = null;
  validationModalValue = false;
  public isMappingResultRoute = false;
  selectedChunk: any = null;
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand: any;
  @ViewChild('resultBox') resultBox!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChildren(MatSort) sectionSorts!: QueryList<MatSort>;
  private _snackBar = inject(MatSnackBar);
  readonly dialog = inject(MatDialog);
  displayedColumns: string[] = [
    'attribute_name',
    'value',
    'validation',
    'rationale',
    'chunks',
    'confidence_level_percentage',
    'reaction',
    'feedback',
  ];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  doc_run_id = '';
  doc_req_id = '';
  year = '';
  quarter = '';
  isEditMode: boolean = false;
  isConfirmValidation: boolean = false;
  isDataChanged: boolean = false;
  isUpdateResultsEnabled: boolean = false;
  isUpdatingResults: boolean = false;
  doc_url = '';
  pdfUrl: SafeUrl | null = null;
  private currentPdfObjectUrl: string | null = null;
  private pendingPdfBlob: Blob | null = null;
  private viewerSettingInProgress: boolean = false;
  private viewerSettingTimeoutId: any = null;
  isPdfLoading = false;
  showNoDocument = true;
  pageNumber: number = 1;
  tableData: any;
  allTabs: string[] = [];
  updatedElements: any[] = [];
  extractionStatus: any;
  originPage: number | null = null;
  // add @ViewChild for #tabFilter and #levelFilter
  @ViewChild('tabFilter') tabFilter: any;
  @ViewChild('levelFilter') levelFilter: any;

  motifTabSelected: any = [];
  motifLevelSelected: any = 'All';
  motifTabOptions: any[] = [
    'Relationship Overview',
    'Repayment Analysis',
    'Covenant Analysis',
    'Collateral Analysis',
    'Regulatory Rating',
  ];
  motifLevelOptions: any[] = [];
  // Validation filter flags: when both false => no validation filtering
  validationIconsOnly: boolean = false;
  noValidationIconsOnly: boolean = false;
  showValidationFilterPopup: boolean = false;
  validationPopupTop: number = 0;
  validationPopupRight: number = 0;
  validationPopupLeft: number = 0;
  private validationPopupAnchorEl: any = null;
  private validationPopupScrollHandler: any = null;
  private validationPopupOutsideClickHandler: any = null;
  public searchText: string = '';
  groupedBySection: { [section: string]: any[] } = {};
  sectionOrder: string[] = [];
  sectionDataSources: { [section: string]: MatTableDataSource<any> } = {};
  sectionLevels: { [section: string]: number } = {};
  isSectionModalOpen: boolean = false;
  sectionModalTitle: string = '';
  sectionModalData: any[] = [];
  sectionInfoResult$: Observable<any> | null = null;
  @ViewChild('sectionHtml', { static: false }) sectionHtmlRef?: ElementRef;
  lastSectionHtml: string = '';
  editedFieldNames: Set<string> = new Set();

  // Returns true if the field should be disabled (max edits reached and this field is not edited)
  isFieldDisabled(row: any): boolean {
    if (!this.isEditMode) return false;
    if (this.editedFieldNames.size < 3) return false;
    if (!row || !row.data_element_name) return false;
    return !this.editedFieldNames.has(row.data_element_name);
  }

  isRegulatory(section: any): boolean {
    try {
      return (section || '').toString().trim().toLowerCase() === 'regulatory rating';
    } catch (e) {
      return false;
    }
  }

  isRegulatoryActive(): boolean {
    try {
      if (Array.isArray(this.motifTabSelected)) {
        return this.motifTabSelected.some((t: any) => (t || '').toString().trim().toLowerCase() === 'regulatory rating');
      }
      if (typeof this.motifTabSelected === 'string') {
        return (this.motifTabSelected || '').toString().trim().toLowerCase() === 'regulatory rating';
      }
    } catch (e) {
      // ignore
    }
    return false;
  }

  // Call this on textarea change
  onFieldEdit(row: any) {
    this.editedFieldNames.add(row.data_element_name);
    this.markUpdate(row);
    // Show snackbar if 3 fields have been edited
    if (this.editedFieldNames.size === 3) {
      this._snackBar.open('You can only edit 3 fields at a time. Please save or cancel to edit more.', 'Close', {
        duration: 4000,
        verticalPosition: 'top',
        panelClass: ['snackbar-warning']
      });
    }
  }

  repositionValidationPopup() {
    try {
      const el = this.validationPopupAnchorEl;
      const rect = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if (rect) {
        this.validationPopupTop = rect.bottom + 6;
        const desiredLeft = rect.right - 160;
        const maxLeft = window.innerWidth - 180;
        const left = Math.max(8, Math.min(desiredLeft, maxLeft));
        this.validationPopupLeft = left;
        // keep fallback right value for compatibility
        this.validationPopupRight = Math.max(8, Math.min(desiredLeft, maxLeft));
      }
    } catch (e) {
      // ignore
    }
  }

    toggleValidationFilterPopup(open?: boolean) {
    if (typeof open === 'boolean') {
      this.showValidationFilterPopup = open;
    } else {
      this.showValidationFilterPopup = !this.showValidationFilterPopup;
    }
    if (!this.showValidationFilterPopup) {
      try { window.removeEventListener('scroll', this.validationPopupScrollHandler, true); } catch {}
      try { window.removeEventListener('resize', this.validationPopupScrollHandler); } catch {}
      try { window.removeEventListener('mousedown', this.validationPopupOutsideClickHandler, true); } catch {}
      this.validationPopupAnchorEl = null;
      this.validationPopupScrollHandler = null;
      this.validationPopupOutsideClickHandler = null;
    } else {
      this.repositionValidationPopup();
    }
  }

  openValidationPopupAt(event: any) {
    try {
      const rect = (event && event.target && event.target.getBoundingClientRect) ? event.target.getBoundingClientRect() : null;
      if (rect) {
        this.validationPopupTop = rect.bottom + 20; // a bit below the button
        const desiredLeft = rect.right - 160;
        const maxLeft = window.innerWidth - 180;
        this.validationPopupLeft = Math.max(8, Math.min(desiredLeft, maxLeft));
        // force to 320px as requested
        this.validationPopupLeft = 320;
        // keep fallback right value for compatibility
        this.validationPopupRight = this.validationPopupLeft;
      } else if (event && event.clientX && event.clientY) {
        this.validationPopupTop = event.clientY + 20;
        this.validationPopupLeft = 320;
      } else {
        this.validationPopupTop = 140;
        this.validationPopupLeft = 320;
      }
    } catch (e) {
      this.validationPopupTop = 140;
      this.validationPopupLeft = 320;
    }
    this.validationPopupAnchorEl = event && event.currentTarget ? event.currentTarget : (event && event.target ? event.target : null);
    this.validationPopupScrollHandler = () => this.repositionValidationPopup();
    window.addEventListener('scroll', this.validationPopupScrollHandler, true);
    window.addEventListener('resize', this.validationPopupScrollHandler);
    // outside click handler
    this.validationPopupOutsideClickHandler = (ev: any) => {
      try {
        const popup = document.querySelector('.validation-filter-popup');
        const anchor = this.validationPopupAnchorEl;
        const target = ev.target as Node;
        if (popup && (popup === target || popup.contains(target))) return;
        if (anchor && (anchor === target || anchor.contains && anchor.contains(target))) return;
        // click outside
        this.toggleValidationFilterPopup(false);
        this.validationPopupOutsideClickHandler = null;
      } catch (e) {}
    };
    window.addEventListener('mousedown', this.validationPopupOutsideClickHandler, true);
    this.showValidationFilterPopup = true;
  }

openDependentValueModal (row: any) {
  try {
    this.dialog.open(DependentValueModalComponent, {
      width: '800px',
      maxWidth: '95vw',
      data: { ai_answer_list: row && Array.isArray(row.ai_answer_list) ? row.ai_answer_list : [] },
      autoFocus: false
    });
  } catch (e) {
    console.error('Failed to open dependent value modal', e);
    }
  }

  // Call this on Save or Cancel to reset
  resetEditedFields() {
    this.editedFieldNames.clear();
  }

  openSectionModal(section: string) {
    let activeTab = '';
    if (Array.isArray(this.motifTabSelected) && this.motifTabSelected.length > 0) {
      activeTab = this.motifTabSelected[0];
    } else if (typeof this.motifTabSelected === 'string' && this.motifTabSelected) {
      activeTab = this.motifTabSelected;
    }
    let tabNameToSend = activeTab === 'Relationship Overview' ? 'Relationship overview' : activeTab;
    this.sectionModalTitle = section;
    this.sectionModalData = [];
    this.sectionInfoResult$ = this.mappingResultService.getSectionInfo({
      extraction_run_id: this.extraction_run_id,
      section_name: section,
      tab_name: tabNameToSend,
      sub_product: this.sub_product
    });
    this.isSectionModalOpen = true;
  }

  closeSectionModal() {
    this.isSectionModalOpen = false;
    this.sectionModalTitle = '';
    this.sectionModalData = [];
  }

  getObjectKeys(obj: any): string[] {
    return getObjectKeys(obj);
  }

  // Return true if any non-'All' tab has readonly attributes
  hasAnyReadonlyAttributes(): boolean {
    try {
      if (!Array.isArray(this.tabNames) || !this.readonlyAttributesMap) return false;
      return this.tabNames.some((tab: any) => tab !== 'All' && this.readonlyAttributesMap[tab] && this.readonlyAttributesMap[tab].length > 0);
    } catch (e) {
      return false;
    }
  }

  groupDataBySection(data: any[]): void {
    const result = groupDataBySection(data);
    this.groupedBySection = result.groupedBySection;
    this.sectionOrder = result.sectionOrder;
    this.sectionDataSources = result.sectionDataSources;
  }

  shouldShowSectionIcon(section: string): boolean {
    return shouldShowSectionIcon(section, this.sectionDataSources);
  }

  private collapseAllDependents() {
    collapseAllDependents(this.sectionDataSources);
  }

  onSectionHeaderClick(i: number) {
    this.collapseAllDependents();
    this.expandedSectionIndex = this.expandedSectionIndex === i ? -1 : i;
  }

  ngAfterViewInit(): void {
    ChatbotDialogComponent.documentOpen$.subscribe((event: any) => {
      if (event && event.type === 'start') {
        this.isPdfLoading = true;
        this.showNoDocument = false;
        this.cdr.detectChanges();
        setTimeout(() => {
          if (this.resultBox && this.resultBox.nativeElement) {
            this.resultBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
      }, 0);
      }
    });

    this.componentSubscriptions.add(this.mappingResultService.extractionTrigger.subscribe((payload: any) => {
      try {
        if (!this.router.url.includes('/mapping-result')) return;
        if (payload && payload.doc_run_id && payload.doc_run_id === this.doc_run_id) {
          this.extractionStatus = 'IN_PROGRESS';
          this.isUpdateResultsEnabled = false;
          // keep spinner/flag to show updating state
          this.isUpdatingResults = true;
          // start polling feedback summary while re-run is active
          try { if (!this.feedbackSummaryPollId) { this.feedbackSummaryPollId = setInterval(() => { try { this.getFeedbackSummary(); } catch(e) {} }, 5000); } } catch(e) {}
          // If a new request_id was provided as part of the rerun trigger, immediately switch
          // to using it for all subsequent summary / feedback / rerun API calls so we don't
          // have to rely on a page refresh to pick it up.
          if (payload.request_id && payload.request_id !== this.doc_req_id) {
            this.doc_req_id = payload.request_id;
            // Update the URL (merge other existing query params) so a manual refresh keeps new id
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: { doc_req_id: this.doc_req_id },
              queryParamsHandling: 'merge',
              replaceUrl: true
            });
            this.getFeedbackSummary();
          }
          this.cdr.detectChanges();
        }
      } catch (e) {
        // ignore
      }
    }));

    // Listen for extraction completion to update status
    this.mappingResultService.extractionCompleted.subscribe((completedDocRunId: string) => {
      if (completedDocRunId && completedDocRunId === this.doc_run_id) {
        this.extractionStatus = 'COMPLETED';
        // Disable Update Results immediately and clear any pending L0 update flags
        this.isUpdateResultsEnabled = false;
        this.isUpdatingResults = false;
        // stop feedback polling
        try { if (this.feedbackSummaryPollId) { clearInterval(this.feedbackSummaryPollId); this.feedbackSummaryPollId = null; } } catch(e) {}
        try {
          if (Array.isArray(this.tableData)) {
            let mutated = false;
            this.tableData.forEach((row: any) => {
              const level = row?.level;
              const isL0 = level === 0 || level === '0' || String(level) === '0';
              if (isL0 && row?.is_updated_value === true) {
                // Mark that the updated results have now been applied by the completed extraction
                if (row.is_updated_results !== true) {
                  row.is_updated_results = true;
                  mutated = true;
                }
              }
            });
            if (mutated) {
              // Recompute the enable state in case UI logic relies on flags
              this.isUpdateResultsEnabled = this.shouldEnableUpdateResults(this.tableData);
            }
          }
        } catch (e) {
          // ignore
        }
        this.cdr.detectChanges();
      }
    });
  }
  motifLog(message: string) {
    console.log(message);
  }
  motifOnTabSelectionChange(event: any) {
    this.motifTabSelected = event;
    this.filterDataSourceMotif();
  }
  motifOnLevelSelectionChange(event: any) {
    this.motifLevelSelected = event;
    this.filterDataSourceMotif();
  }
  setTabFilter(tab: string) {
    this.motifTabSelected = [tab];
    this.filterDataSourceMotif();
  }
  filterDataSourceMotif() {
    if (!Array.isArray(this.tableData)) {
      return;
    }
    let tabs = Array.isArray(this.motifTabSelected)
      ? this.motifTabSelected
      : [this.motifTabSelected];
    let levels = Array.isArray(this.motifLevelSelected)
      ? this.motifLevelSelected
      : [this.motifLevelSelected];
    tabs = tabs.filter((tab) => tab !== 'All Tabs');
    levels = levels.filter((level) => level !== 'All');

    let filtered = this.tableData;

    // If no tabs are selected, show all sections
    if (tabs.length === 0) {
      filtered = this.tableData;
    } else if (tabs.length === 1) {
      const selectedTab = (tabs[0] || '').toString().trim().toLowerCase();
      filtered = filtered.filter((d: any) => {
        const rowTab = (d.tab_name || '').toString().trim().toLowerCase();
        return rowTab === selectedTab;
      });
    }
    // include level 0, 1, and 2
    if (levels.length >= 0) {
      filtered = filtered.filter((d: any) => {
        const levelStr = d.level?.toString();
        return levels.includes(levelStr) || levels.includes('0') && (levelStr === '0' || levelStr === 0);
      });
    }

    if (this.searchText && this.searchText.trim() !== '') {
      const searchLower = this.searchText.trim().toLowerCase();
      filtered = filtered.filter((element: any) =>
        (element.data_element_name || '').toLowerCase().includes(searchLower) ||
        (element.tab_name || '').toLowerCase().includes(searchLower)
      );
    }

    // Apply validation icons/no-icons filtering
    if (this.validationIconsOnly || this.noValidationIconsOnly) {
      // if both selected, treat as no filter (show all)
      if (!(this.validationIconsOnly && this.noValidationIconsOnly)) {
        filtered = filtered.filter((d: any) => {
          try {
            const hasIcons = Array.isArray(d.ai_answer_list) && d.ai_answer_list.length > 0;
            if (this.validationIconsOnly) {
              return !!hasIcons;
            }
            if (this.noValidationIconsOnly) {
              return !hasIcons;
            }
            return true;
          } catch (e) { return false; }
        });
      }
    }

    this.dataSource = new MatTableDataSource(filtered);
    this.groupDataBySection(filtered);
  }
  isModalOpen: boolean = false;
  selectedFile: File | null = null;
  isUploadModalOpen: boolean = false;
  isUploading: boolean = false;
  sub_product: string = '';
  tabName: string = '';
  extraction_run_id: string = '';
  expandedRows: { [key: string]: boolean } = {};

  navigationList: any[] = [];
  feedbackSummary = { total: 0, positive: 0, reviewed: 0 };
  feedbackSummaryLoading: boolean = false;
  // Subject to coordinate feedback summary requests and avoid duplicate calls
  private feedbackIds$ = new BehaviorSubject<{ req?: string | null; run?: string | null }>({ req: null, run: null });
  private feedbackSummarySub: Subscription | null = null;
  private feedbackSummaryPollId: any = null;
  private componentSubscriptions = new Subscription();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private layoutService: LayoutService,
    private service: LoanAiService,
    private mappingResultService: MappingResultService,
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef
  ) {
    this.route.queryParams.subscribe((queryParams) => {
    this.fetchDocumentList();
    this.isMappingResultRoute = this.router.url.includes('mapping-result');
    this.router.events?.subscribe(() => {
      this.isMappingResultRoute = this.router.url.includes('mapping-result');
    });
      this.doc_run_id = queryParams['doc_run_id'];
      this.doc_req_id = queryParams['doc_req_id'];
      this.year = queryParams['year'];
      this.quarter = queryParams['quarter'];
      this.extractionStatus = queryParams['extractionStatus'];
      this.sub_product = queryParams['sub_product'];
      if (queryParams['page'] !== undefined) {
        const p = parseInt(queryParams['page'], 10);
        if (!isNaN(p)) {
          this.originPage = p;
        }
      }
      this.navigationList = [
        { value: 'Loan File Review', link: 'view-details', expanded: false },
        { value: queryParams['product'] || 'Corporate Loan', link: 'view-details', expanded: false },
        { value: queryParams['subproduct'] || this.sub_product || 'Loan File Review', link: 'view-details', expanded: false },
        { value: queryParams['asset_class'] || 'Asset class', link: 'view-details', expanded: false },
        { value: queryParams['data_element'] || 'Borrower name', link: 'view-details', expanded: false },
      ];
      if (this.doc_run_id) {
        this.mappingResultService.getCommentsCount(this.doc_run_id).subscribe({
          next: (counts) => {
            this.commentCounts = counts || {};
          },
          error: () => {
            this.commentCounts = {};
          }
        });
      }
      this.mappingResultService.extractionCompleted.subscribe((completedDocRunId: string) => {
        if (completedDocRunId && this.doc_run_id && completedDocRunId === this.doc_run_id) {
          this.isUpdateResultsEnabled = false;
        }
      });
      this.getMappingResult();
    });

    // Listen for external announcements of a new request_id (fresh extraction or bulk run)
    this.componentSubscriptions.add(this.mappingResultService.requestIdUpdates.subscribe((u) => {
      if (!this.router.url.includes('/mapping-result')) return;
      if (u && u.doc_run_id && u.request_id && u.doc_run_id === this.doc_run_id) {
        if (u.request_id !== this.doc_req_id) {
          this.doc_req_id = u.request_id;
          // Persist new request id in URL
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { doc_req_id: this.doc_req_id },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
          // Reload data using new request id
          this.getMappingResult();
          this.getFeedbackSummary();
          // Ensure Update Results button remains disabled while the rerun is active
          this.isUpdateResultsEnabled = false;
          this.isUpdatingResults = true;
          try { if (!this.feedbackSummaryPollId) { this.feedbackSummaryPollId = setInterval(() => { try { this.getFeedbackSummary(); } catch(e) {} }, 5000); } } catch(e) {}
        }
      }
    }));

    this.service.pdfLoading$.subscribe((loading: boolean) => {
      this.isPdfLoading = loading;
    });
    this.service.pdfClear$.subscribe(() => {
    this.isPdfLoading = true;
    this.setPdfViewerSrc(null);
    });
    this.service.pdfBlob$.subscribe((blob: Blob) => {
      this.showNoDocument = false;
      // Clear any previous object URL
      try { if (this.currentPdfObjectUrl) { window.URL.revokeObjectURL(this.currentPdfObjectUrl); } } catch (e) {}
      try { this.currentPdfObjectUrl = null; } catch (e) {}
      // Create new object URL and set iframe src
      try {
        const url = window.URL.createObjectURL(blob);
        this.currentPdfObjectUrl = url;
        try { this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url); } catch (e) { this.pdfUrl = url as any; }
      } catch (e) {
        console.error('Failed to create object URL for PDF blob', e);
        this.pdfUrl = null as any;
      }
      this.isPdfLoading = false;
      setTimeout(() => {
        if (this.resultBox && this.resultBox.nativeElement) {
          this.resultBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
    });
    this.service.pdfPageNumber$.subscribe((page: number) => {
      if (typeof page === 'number' && page > 0) {
        this.pageNumber = page;
      }
    });
    this.route.queryParams.subscribe((queryParams) => {
      const subProduct = queryParams['subproduct'] || this.sub_product;
      if (subProduct) {
        this.mappingResultService.getTabNames(subProduct).subscribe((tabs: string[]) => {
        this.tabNames = ['All', ...tabs];
        this.selectedTabName = '';
        });
      }
    });
  }

  private setPdfViewerSrc(source: Blob | string | null) {
    // Simple helper: set iframe-compatible object URL or clear it.
    try {
      // revoke previous
      try { if (this.currentPdfObjectUrl) { window.URL.revokeObjectURL(this.currentPdfObjectUrl); } } catch (e) {}
      this.currentPdfObjectUrl = null;
      if (!source) {
        try { this.pdfUrl = null as any; } catch (e) {}
        return;
      }
      if (source instanceof Blob) {
        try {
          const url = window.URL.createObjectURL(source);
          this.currentPdfObjectUrl = url;
          this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        } catch (e) {
          console.error('Failed to create object URL for blob', e);
          this.pdfUrl = null as any;
        }
      } else {
        try { this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(source as string); } catch (e) { this.pdfUrl = source as any; }
      }
      this.isPdfLoading = false;
    } catch (e) {
      console.error('setPdfViewerSrc error', e);
    }
  }

  
  tabNames: string[] = [];
  selectedTabName: string = '';
  // Readonly attributes per tab for the generate modal accordion (loaded from API)
  readonlyAttributesMap: { [tab: string]: string[] } = {};

  // Load readonly attributes mapping for either a specific tab or all tabs
  loadReadonlyAttributes(tabName: string) {
    const tabParam = tabName && tabName.trim() !== '' ? tabName : 'ALL';
    // ensure we have identifiers available
    if (!this.doc_run_id || !this.doc_req_id) return;
    this.mappingResultService
      .getAttributeValidation({
        doc_run_id: this.doc_run_id,
        request_id: this.doc_req_id,
        tab_name: tabParam === 'ALL' ? 'ALL' : tabParam,
      })
      .subscribe({
        next: (res: any) => {
          // If API returns tab->attributes mapping use it directly
          if (res && typeof res === 'object') {
            // Normalize response: if res.attributes exists, map it to the tab
            if (res.attributes && Array.isArray(res.attributes) && tabParam !== 'ALL') {
              this.readonlyAttributesMap[tabParam] = res.attributes;
            } else {
              // assume res is a mapping of tab -> attributes
              this.readonlyAttributesMap = res;
            }
          }
        },
        error: (err) => {
          console.error('Failed to load readonly attributes', err);
        },
      });
  }

  openFeedbackCategoryModal(element: any, markNegative: boolean = true) {
    const userEmail = this.profileService.getUserEmail();
    const dialogRef = this.dialog.open(
      FeedbackCategoryModalComponent,
      {
        width: '400px',
        disableClose: true,
        data: {
          doc_run_id: this.doc_run_id,
          request_id: this.doc_req_id,
          data_element_name: element.data_element_name,
          updated_by: userEmail
        }
      }
    );
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && markNegative) {
        const comment = (result && result.comment !== undefined) ? (result.comment || '') : '';
        const category = (result && result.category) ? result.category : '';
        const payload = {
          doc_run_id: this.doc_run_id,
          request_id: this.doc_req_id,
          data_element_name: element.data_element_name,
          updated_confidence_validation: false,
          previous_confidence_validation: element.confidence_level_validation === null ? null : !!element.confidence_level_validation,
          updated_by: this.profileService.getUserEmail(),
          ai_answer: element.ai_answer || '',
          category_name: category,
          comments: comment ? [comment] : []
        };
        this.mappingResultService.updateAttributeValidation(payload).subscribe({
          next: () => {
            element.confidence_level_validation = false;
            element.category_name = category || '';
            this._snackBar.open('Feedback submitted', 'ok', { duration: 2000 });
            this.getMappingResult();
              // refresh feedback summary counts after submitting feedback
              if (this.doc_req_id && this.doc_run_id) {
                this.mappingResultService.getFeedbackSummaryRequest(this.doc_req_id, this.doc_run_id).subscribe({
                  next: (data) => {
                    this.feedbackSummary.total = data?.total_data_elements ?? 0;
                    this.feedbackSummary.positive = data?.total_positives ?? 0;
                    this.feedbackSummary.reviewed = data?.reviewed ?? data?.user_review_count ?? 0;
                  },
                  error: () => {
                    // ignore
                  }
                });
              }
            if (this.doc_run_id) {
              this.mappingResultService.getCommentsCount(this.doc_run_id).subscribe({
                next: (counts) => {
                  this.commentCounts = counts || {};
                },
                error: () => {
                  this.commentCounts = {};
                }
              });
            }
            this.getMappingResult();
          },
          error: () => {
            this._snackBar.open('Failed to update validation', 'ok', { duration: 2000 });
          }
        });
      }
    });
  }

  onTabClick(tab: string) {
    if (this.motifTabSelected.length === 1 && this.motifTabSelected[0] === tab) {
      this.motifTabSelected = [];
    } else {
      this.motifTabSelected = [tab];
    }
    Object.values(this.sectionDataSources).forEach((ds: any) => {
      if (ds && Array.isArray(ds.data)) {
        ds.data.forEach((row: any) => {
          if (row && row.dependentExpanded) {
            row.dependentExpanded = false;
          }
        });
      }
    });
    this.filterDataSourceMotif();
  }

  onThumbsUp(element: any) {
    if (element.confidence_level_validation === true) {
      return;
    }
    const userEmail = this.profileService.getUserEmail();
    const payload = {
      doc_run_id: this.doc_run_id,
      request_id: this.doc_req_id,
      data_element_name: element.data_element_name,
      updated_confidence_validation: true,
      previous_confidence_validation: element.confidence_level_validation === null ? null : !!element.confidence_level_validation,
      updated_by: userEmail,
      ai_answer: element.ai_answer || '',
      category_name: element.category_name || ''
    };
    this.mappingResultService.updateAttributeValidation(payload).subscribe({
      next: () => {
        // mark locally and optimistically update counts for immediate UI feedback
        element.confidence_level_validation = true;
        if (!element.reviewed) {
          element.reviewed = true;
          // optimistic increment
          this.feedbackSummary.reviewed = (this.feedbackSummary.reviewed || 0) + 1;
          this.feedbackSummary.positive = (this.feedbackSummary.positive || 0) + 1;
          this.cdr.detectChanges();
        }
        if (this.doc_req_id && this.doc_run_id) {
          this.mappingResultService.getFeedbackSummaryRequest(this.doc_req_id, this.doc_run_id).subscribe({
            next: (data) => {
              this.feedbackSummary.total = data?.total_data_elements ?? 0;
              this.feedbackSummary.positive = data?.total_positives ?? 0;
              this.feedbackSummary.reviewed = data?.reviewed ?? data?.user_review_count ?? 0;
            },
            error: () => {
              // ignore; keep optimistic values
            }
          });
        }
        this._snackBar.open('Marked as correct', 'ok', { duration: 2000 });
        this.getMappingResult();
      },
      error: () => {
        this._snackBar.open('Failed to update validation', 'ok', { duration: 2000 });
      }
    });
  }

  openAnswerModal(answer: string) {
    this.dialog.open(AnswerModalComponent, {
      width: '700px',
      maxWidth: '95vw',
      data: { answer },
      panelClass: 'custom-answer-modal-panel',
      autoFocus: false
    });
  }

  openValidationSourceModal(element: any) {
    const dialogRef = this.dialog.open(ValidationSourceModalComponent, {
      width: '420px',
      data: {
        ai: element?.ai_answer || '',
        tape: element?.tape_value || element?.tape_answer || '',
        source: element?.traces && element.traces.length ? (element.traces[0].chunk || element.traces[0].text || '') : '',
        ai_answer_list: element?.ai_answer_list || [],
        ai_category: element?.ai_category ?? null,
        has_done_validation: typeof element?.has_done_validation !== 'undefined' ? element.has_done_validation : null,
        is_source_and_tape_value_same: typeof element?.is_source_and_tape_value_same !== 'undefined' ? element.is_source_and_tape_value_same : null,
        validation: element?.validation || null
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        // Build payload for API: map modal `selectedSource` to `validation` ('tape'|'source'|null)
        const payload: any = {
          doc_run_id: this.doc_run_id,
          request_id: this.doc_req_id,
          data_element_name: element.data_element_name,
          validation: res.selected || null
        };
        // If user provided a manual note/value, send it as `value` and set validation to 'MANUAL'
        if (res.note && res.note.toString().trim().length) {
          payload.value = res.note.toString().trim();
          payload.validation = 'MANUAL';
        }

        // Optimistically attach selection locally for immediate UI feedback
        element.validation_source = res;
        this.cdr.detectChanges();

        // Call API to persist validation
        this.mappingResultService.validationUpdate(payload).subscribe({
          next: () => {
            this._snackBar.open('Validation value saved', 'ok', { duration: 2000 });
            this.getMappingResult();
          },
          error: () => {
            this._snackBar.open('Failed to update validation', 'ok', { duration: 2000 });
            // optionally revert optimistic UI change by clearing attached value
            // element.validation_source = null;
            this.getMappingResult();
          }
        });
      }
    });
  }

  openCommentModal(element: any) {
    const userEmail = this.profileService.getUserEmail();
    this.mappingResultService.getHistoryAndComments({
      doc_run_id: this.doc_run_id,
      request_id: this.doc_req_id,
      data_element_name: element.data_element_name
    }).subscribe((res: any) => {
      const comments = res?.comments || [];
      const dialogRef = this.dialog.open(
        CommentModalComponent,
        {
          width: '600px',
          disableClose: true,
          data: {
            doc_run_id: this.doc_run_id,
            request_id: this.doc_req_id,
            data_element_name: element.data_element_name,
            updated_by: userEmail,
            comments: comments
          }
        }
      );
      dialogRef.afterClosed().subscribe((newComment: any) => {
        if (newComment) {
          if (!element.comments) element.comments = [];
          if (typeof newComment === 'string') {
            element.comments.push({
              comment: newComment,
              updated_by: userEmail,
              updated_at: new Date().toISOString(),
              category_name: '',
              id: ''
            });
          } else {
            element.comments.push(newComment);
          }
          const name = element.data_element_name;
          if (name) {
            if (!this.commentCounts[name]) {
              this.commentCounts[name] = 1;
            } else {
              this.commentCounts[name]++;
            }
          }
          this._snackBar.open('Comment added', 'ok', { duration: 2000 });
          this.getMappingResult();
          if (this.doc_run_id) {
            this.mappingResultService.getCommentsCount(this.doc_run_id).subscribe({
              next: (counts) => {
                this.commentCounts = counts || {};
              },
              error: () => {
                this.commentCounts = {};
              }
            });
          }
        }
      });
    });
  }

  onSearchTextChange(): void {
    this.filterDataSourceMotif();
  }

  closePdf(): void {
    this.showNoDocument = true;
    this.isPdfLoading = false;
    this.selectedDocumentIndex = -1;
    this.selectedDocumentId = null;
    // clear iframe/pdf src safely
    try { if (this.currentPdfObjectUrl) { window.URL.revokeObjectURL(this.currentPdfObjectUrl); } } catch (e) {}
    try { this.currentPdfObjectUrl = null; } catch (e) {}
    try { this.pdfUrl = null as any; } catch (e) {}
  }

  onGenerateTabReport(): void {
    if (!this.selectedTabName || !this.sub_product) {
      this._snackBar.open('Please select a tab and ensure subproduct is available.', 'ok', { duration: 2000 });
      return;
    }
    let borrowerName = '';
    if (this.navigationList && this.navigationList.length > 0) {
    const borrowerNav = this.navigationList.find(nav => nav.value && nav.value.toLowerCase().includes('borrower'));
      borrowerName = borrowerNav ? borrowerNav.value : this.navigationList[this.navigationList.length - 1].value;
    }
    const payload = {
      sub_product: this.sub_product,
      tab_name: this.selectedTabName,
      extraction_run_id: this.extraction_run_id,
      borrower_name: borrowerName
    };
    this.mappingResultService.generateReport(payload).subscribe({
      next: (response: any) => {
        const fileInfo = response?.file_info;
        const base64 = fileInfo?.base64_content || fileInfo?.base64;
        let contentType = fileInfo?.content_type || '';
        let filename = `${borrowerName}_${this.sub_product}_${this.selectedTabName}`;
        filename = filename.replace(/[^a-zA-Z0-9-_\.]/g, '_');
        if (base64) {
          if (!contentType || contentType === 'application/octet-stream') {
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          }
          if (contentType === 'application/pdf') {
            if (!filename.endsWith('.pdf')) filename += '.pdf';
          } else {
            if (!filename.endsWith('.docx')) filename += '.docx';
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          }
          const blob = base64ToBlob(base64, contentType);
          if (contentType === 'application/pdf') {
            try { if (this.currentPdfObjectUrl) { window.URL.revokeObjectURL(this.currentPdfObjectUrl); } } catch (e) {}
            try { this.currentPdfObjectUrl = null; } catch (e) {}
            try {
              const url = window.URL.createObjectURL(blob);
              this.currentPdfObjectUrl = url;
              this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
            } catch (e) { console.error('Failed to create object URL for generated report', e); }
          }
          this.downloadFile(blob, filename);
          this._snackBar.open('Tab report generated and downloaded for ' + this.selectedTabName, 'ok', { duration: 2000 });
        } else {
          this._snackBar.open(response?.message || 'Tab report generated', 'ok', { duration: 2000 });
        }
      },
      error: (err: any) => {
        this._snackBar.open('Failed to generate tab report', 'ok', { duration: 2000 });
      }
    });
  }
  updateNavigationList(params: any) {
    this.navigationList = [
      { value: 'Loan File Review', link: 'view-details', expanded: false },
      { value: params?.product || 'Corporate Loan', link: 'view-details', expanded: false },
      { value: params?.subproduct || this.sub_product || 'Loan File Review', link: 'view-details', expanded: false },
      { value: params?.asset_class || 'Asset class', link: 'view-details', expanded: false },
      { value: params?.data_element || 'Borrower name', link: 'view-details', expanded: false },
    ];
  }

  onBreadcrumbClick(nav: any) {
    this.router.navigate(['/view-details'], {
      queryParams: {
        year: this.year,
        quarter: this.quarter,
      },
    });
  }

  isTruncated = isTruncated;
  getTruncated = getTruncated;
  toMarkdownString(val: any): string {
    // Ensure we always return a safe string and escape any HTML characters so
    // user-supplied input cannot inject tags or scripts into generated HTML.
    if (typeof val === 'string') {
      // Convert single newlines into explicit markdown line-breaks (two spaces + newline)
      // so that renderers which don't enable "breaks" still display new lines.
      let withLineBreaks = val.replace(/\r\n|\r|\n/g, '  \n');
      // If the value contains comma-separated dates (e.g. "12-31-2022, 12-31-2023"),
      // convert the commas before dates into markdown line breaks as well.
      withLineBreaks = withLineBreaks.replace(/,\s*(?=\d{1,2}-\d{1,2}-\d{4})/g, '  \n');
      return this.htmlEscape(withLineBreaks);
    }
    if (val === undefined || val === null) return '';
    try {
      return this.htmlEscape(String(val));
    } catch {
      return '';
    }
  }
    htmlEscape(input: string): string {
    if (input === undefined || input === null) return '';
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\//g, '&#x2F;')
      .replace(/\r\n/g, '\n');
  }

  showSideKick = true;
  showChatbot() {
    this.dialog.open(ChatbotDialogComponent, {
      width: '450px',
      height: '90vh',
      position: { bottom: '4px', right: '4px' },
      disableClose: false,
      hasBackdrop: false
    });
    return false;
  }

  toggleExpandRow(rowId: string): void {
    this.expandedRows[rowId] = !this.expandedRows[rowId];
  }

  toggleValueVisibility(rowId: string): void {
    // Treat undefined as hidden by default. Only an explicit `true` means visible.
    const currentlyVisible = this.expandedRows[rowId] === true;
    this.expandedRows[rowId] = !currentlyVisible;
  }
  goBack() {
    this.dataSource = new MatTableDataSource<MapResult>([]);
    const queryParams: any = { year: this.year, quarter: this.quarter };
    if (this.originPage !== null && this.originPage !== undefined) {
      queryParams.page = this.originPage;
    }
    this.router.navigate(['/view-details'], { queryParams });
    return false;
  }

  getMappingResult() {
    this.mappingResultService
      .getMappingResult(this.doc_run_id, this.doc_req_id)
      .subscribe((data) => {
        // console.log(data.run_results, "data")
        this.extraction_run_id = data?.extraction_run_id;
        let rowKeyCounter = 0;
        data.run_results.forEach((element: any) => {
          element.feedback = '';
          element.feedbacks = element.audit_log.filter((log: any) => log.feedback !== '');
          // Initialize comments array from audit log or empty
          element.comments = (element.audit_log
            .filter((log: any) => log.comments && Array.isArray(log.comments) && log.comments.length > 0)
            .map((log: any) => log.comments)
            .flat()) || [];
          element._rowKey = rowKeyCounter++;
          // Normalize confidence_level_validation: if it's undefined, treat as null (unreviewed)
          if (element.confidence_level_validation === undefined) {
            element.confidence_level_validation = null;
          }
          element.reviewed = element.confidence_level_validation === true;
          element._rowKey = rowKeyCounter++;
          element.dependentExpanded = false;
          element.is_updated_value = element.is_updated_value === true;
          element.is_updated_results = element.is_updated_results === true;
          // Persist last negative category for UI coloring after refresh
          try {
            if (element.confidence_level_validation === false) {
              let category = element.category_name || '';
              if (!category && Array.isArray(element.audit_log)) {
                const catLog = [...element.audit_log].reverse().find((log: any) => !!log?.category_name);
                category = catLog?.category_name || '';
              }
              element.category_name = category;
            } else {
              element.category_name = '';
            }
          } catch {}
        });

        // Populate tab options dynamically from returned run_results
        try {
          const tabs = Array.from(new Set((data.run_results || []).map((r: any) => (r.tab_name || r.section_name || '').toString()).filter((t: string) => t && t.trim() !== '')));
          const fixedTabOrder = [
            'Relationship Overview',
            'Repayment Analysis',
            'Covenant Analysis',
            'Collateral Analysis',
            'Regulatory Rating'
          ];
          // If API also returns explicit tab list prefer that, but normalize and sort to fixed order
          let candidateTabs: string[] = [];
          if (Array.isArray(data.tab_names) && data.tab_names.length > 0) {
            candidateTabs = (data.tab_names as any[]).map((t: any) => (t || '').toString().trim()).filter((t: string) => t);
          } else if (tabs.length > 0) {
            candidateTabs = (tabs as any[]).map((t: any) => (t || '').toString().trim());
          }
          if (candidateTabs.length > 0) {
            this.motifTabOptions = candidateTabs.sort((a: string, b: string) => {
              const ia = fixedTabOrder.indexOf(a);
              const ib = fixedTabOrder.indexOf(b);
              const pa = ia === -1 ? Number.MAX_SAFE_INTEGER : ia;
              const pb = ib === -1 ? Number.MAX_SAFE_INTEGER : ib;
              return pa - pb;
            });
          }
        } catch (e) {
          // leave motifTabOptions empty and fallback to existing defaults elsewhere
        }

        this.tableData = data.run_results;
        this.dataSource = new MatTableDataSource(data.run_results);
        this.motifLevelOptions = [
          { value: '0', label: 'Level 0' },
          { value: '1', label: 'Non Narrative' },
          { value: '2', label: 'Narrative' },
        ];
        if (!this.motifTabSelected || this.motifTabSelected.length === 0) {
          if (this.motifTabOptions && this.motifTabOptions.length > 0) {
            this.motifTabSelected = [this.motifTabOptions[0]];
          }
        }
        this.motifLevelSelected = this.motifLevelOptions.map(opt => opt.value);
        this.filterDataSourceMotif();
        this.isUpdateResultsEnabled = this.shouldEnableUpdateResults(this.tableData);
        this.getFeedbackSummary();
      });
  }

  /**
   * Compute validation UI state based on flags described by product rules.
   * Returns an object with color, icon and whether radio choices should be disabled.
   */
  computeValidationState(row: any) {
    // Default state
    const state: any = { color: '#D32F2F', icon: 'radio_button_unchecked', disableRadios: false };
    try {
      const a = typeof row.is_source_and_tape_value_same !== 'undefined' ? row.is_source_and_tape_value_same : null;
      const b = typeof row.has_done_validation !== 'undefined' ? row.has_done_validation : null;

      // Case: ai_answer_list empty -> disable tape/source radios except manual
      const aiListEmpty = !Array.isArray(row.ai_answer_list) || row.ai_answer_list.length === 0;
      // NOTE: Temporarily disabled the explicit "not found in documents" handling
      // because it was causing aggressive disabling of radio choices. Re-enable
      // when product rules around "not found" are finalised.
      /*
      try {
        if (Array.isArray(row.ai_answer_list) && row.ai_answer_list.length > 0) {
          const low = (s: any) => (s || '').toString().toLowerCase().trim();
          const anyNotFound = row.ai_answer_list.some((i: any) => low(i.result) === 'not found in documents');
          if (anyNotFound) {
            state.color = '#D32F2F';
            state.icon = 'warning';
            state.disableRadios = true;
            return state;
          }
        }
      } catch (e) {}
      */
      if (aiListEmpty) {
        state.color = '#D32F2F'; // red
        state.icon = 'warning';
        state.disableRadios = true;
        return state;
      }

      // 1. A true => checkmark (green)
      if (a === true) {
        state.color = '#388E3C';
        state.icon = 'check_circle';
        state.disableRadios = false;
        return state;
      }

      // 2. A & B false => yellow icon
      if (a === false && b === false) {
        state.color = '#FBC02D';
        state.icon = 'warning';
        state.disableRadios = false;
        return state;
      }

      // 3. A is null and B is false => red icon, radios disabled
      if ((a === null || typeof a === 'undefined') && b === false) {
        state.color = '#D32F2F';
        state.icon = 'warning';
        state.disableRadios = true;
        return state;
      }

      // 4. A false & B true => checkmark
      if (a === false && b === true) {
        state.color = '#388E3C';
        state.icon = 'check_circle';
        state.disableRadios = false;
        return state;
      }

      // 5. A null & B true => green and radios disabled
      if ((a === null || typeof a === 'undefined') && b === true) {
        state.color = '#388E3C';
        state.icon = 'check_circle';
        state.disableRadios = true;
        return state;
      }

      // fallback: if confidence validation exists show check/cancel
      if (row.confidence_level_validation === true) {
        state.color = '#388E3C';
        state.icon = 'check_circle';
        return state;
      }
      if (row.confidence_level_validation === false) {
        state.color = '#D32F2F';
        state.icon = 'warning';
        return state;
      }

      return state;
    } catch (e) {
      return state;
    }
  }

  ngAfterViewChecked(): void {
    if (this.sectionHtmlRef && this.sectionHtmlRef.nativeElement) {
      const html = this.sectionHtmlRef.nativeElement.innerHTML;
      if (html !== this.lastSectionHtml) {
        this.lastSectionHtml = html;
        const tables = this.sectionHtmlRef.nativeElement.querySelectorAll('table');
        tables.forEach((table: HTMLTableElement) => {
          const firstRow = table.querySelector('tr');
          if (firstRow && firstRow.children.length > 0) {
            const allEmpty = Array.from(firstRow.children).every(
              (cell: any) => !cell.textContent || cell.textContent.trim() === ''
            );
            if (allEmpty) {
              firstRow.remove();
            }
          }
        });
      }
    }
  }

  getChunkTooltipMarkdown(chunk: any): string {
    if (!chunk) return '';
    const docCategory = chunk.doc_classification || chunk.doc_category || chunk.document_category || chunk.category || chunk.doc_label || chunk.docLabel || '--';
    const docName = chunk.original_filename || chunk.doc_name || 'Unknown';
    const page = chunk.page_number || chunk.page || '-';
    // const chunkText = this.removeHtmlTags(chunk.chunk || '');
    // Markdown list so each property appears on its own line
    // const safeChunk = chunkText || '';
    return `- **Document Category:** ${docCategory}\n- **Document Name:** ${docName}\n- **Page:** ${page}`;
  }

  // Return the preferred display value: tape value if present, otherwise AI answer
  getDisplayValue(row: any): string {
    if (!row) return '';
    if (row.tape_value !== undefined && row.tape_value !== null && String(row.tape_value).trim() !== '') return String(row.tape_value);
    if (row.tape_answer !== undefined && row.tape_answer !== null && String(row.tape_answer).trim() !== '') return String(row.tape_answer);
    // Support manual/user-entered values if present
    if (row.manual_input !== undefined && row.manual_input !== null && String(row.manual_input).trim() !== '') return String(row.manual_input);
    if (row.manual_value !== undefined && row.manual_value !== null && String(row.manual_value).trim() !== '') return String(row.manual_value);
    if (row.manual_answer !== undefined && row.manual_answer !== null && String(row.manual_answer).trim() !== '') return String(row.manual_answer);
    // Some payloads use `user_input`/`user_answer`
    if (row.user_input !== undefined && row.user_input !== null && String(row.user_input).trim() !== '') return String(row.user_input);
    if (row.user_answer !== undefined && row.user_answer !== null && String(row.user_answer).trim() !== '') return String(row.user_answer);
    return row.ai_answer !== undefined && row.ai_answer !== null ? String(row.ai_answer) : '';
  }

  // Determine a short label indicating where the displayed value came from
  getDisplaySourceLabel(row: any): string | null {
    if (!row) return null;
    // Prefer explicit ai_category if provided;
    let cat = (row.ai_category || '').toString().trim();
    if (cat && cat.toLowerCase() !== 'none' && cat.toLowerCase() !== 'null') {
      const lower = cat.toLowerCase();
      if (lower === 'source_value' || lower === 'source value' || lower === 'source') return 'Source Value';
      if (lower === 'tape_value' || lower === 'tape value' || lower === 'tape') return 'Tape Value';
      if (lower === 'manual_input' || lower === 'manual input' || lower === 'manual') return 'Manual Input';
      return cat;
    }

    // Fallback: inspect ai_answer_list for common categories
    if (Array.isArray(row.ai_answer_list)) {
      // Try to find a distinct Source entry
      const sourceEntry = row.ai_answer_list.find((a: any) => (a.category || '').toString().toLowerCase().includes('source'));
      if (sourceEntry) return sourceEntry.category || 'Source Value';
      // Try to find a Tape entry
      const tapeEntry = row.ai_answer_list.find((a: any) => (a.category || '').toString().toLowerCase().includes('tape'));
      if (tapeEntry) return tapeEntry.category || 'Tape Value';
      const manualEntry = row.ai_answer_list.find((a: any) => (a.category || '').toString().toLowerCase().includes('manual'));
      if (manualEntry) return manualEntry.category || 'Manual Input';
      // If list has a single entry with a category, use it
      if (row.ai_answer_list.length === 1 && row.ai_answer_list[0].category) return row.ai_answer_list[0].category;
    }

    // If values come from both source and tape, optionally show combined label
    if (row.is_source_and_tape_value_same === true) {
      return 'Source & Tape';
    }

    return null;
  }

  getFeedbackSummary() {
      // Emit ids into the centralized subject; subscription will handle API call with debounce/dedupe.
      if (!this.doc_req_id || !this.doc_run_id) return;
      try {
        this.feedbackIds$.next({ req: this.doc_req_id, run: this.doc_run_id });
      } catch (e) {
        // fallback to direct call if subject fails for any reason
        this.feedbackSummaryLoading = true;
        this.mappingResultService.getFeedbackSummaryRequest(this.doc_req_id, this.doc_run_id).subscribe({
          next: (data) => {
            this.feedbackSummary.total = data?.total_data_elements ?? 0;
            this.feedbackSummary.positive = data?.total_positives ?? 0;
            this.feedbackSummary.reviewed = data?.reviewed ?? data?.user_review_count ?? 0;
            this.feedbackSummaryLoading = false;
          },
          error: () => {
            this.feedbackSummaryLoading = false;
          }
        });
      }
  }

  getStatusClass(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'completed':
        return 'status-completed';
      case 'partial_completed':
        return 'status-partial';
      case 'failed':
        return 'status-failed';
      case 'in_progress':
        return 'status-inprogress';
      case 'pending':
        return 'status-pending';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return '';
    }
  }

  /**
   * Map internal extraction status values to human-friendly labels used in the UI.
   */
  getExtractionStatusLabel(status: string | null | undefined): string {
    if (!status && status !== '') return '';
    const s = (status || '').toString().toUpperCase();
    switch (s) {
      case 'FAILED':
        return 'Failed';
      case 'PARTIAL_COMPLETED':
        return 'Partial Completed';
      case 'COMPLETED':
        return 'Completed';
      case 'PENDING':
        return 'Pending';
      case 'IN_PROGRESS':
        return 'In Progress';
      case 'CANCELLED':
        return 'Cancelled';
      default:
        // Fallback: try to prettify common cases (e.g., 'IN_PROGRESS' or 'PARTIAL_COMPLETED')
        return status || '';
    }
  }

  ngOnInit(): void {
    this.fetchDocumentList();
    this.matIconRegistry.addSvgIcon(
      'feedback',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        './images/icons/feedback.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'wand_stars',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        './images/icons/wand_stars.svg'
      )
    );
    if (!this.motifTabSelected || this.motifTabSelected.length === 0) {
      if (this.motifTabOptions && this.motifTabOptions.length > 0) {
        this.motifTabSelected = [this.motifTabOptions[0]];
      }
    }

    // show sidekick
    this.layoutService.displaySideKick(true);
    // show sidenav
    this.layoutService.displaySideNav(true);

    // Subscribe to feedback id changes and call feedback summary API only when ids change.
    // Debounce briefly and dedupe so multiple rapid assignments don't trigger multiple requests.
    try {
      this.feedbackSummarySub = this.feedbackIds$.pipe(
        map(ids => `${ids.req || ''}::${ids.run || ''}`),
        distinctUntilChanged(),
        debounceTime(50),
        switchMap((key) => {
          const parts = key.split('::');
          const req = parts[0] || null;
          const run = parts[1] || null;
          if (!req || !run) return of(null);
          this.feedbackSummaryLoading = true;
          return this.mappingResultService.getFeedbackSummaryRequest(req, run).pipe(
            catchError(() => of(null))
          );
        })
      ).subscribe((data: any) => {
        if (data) {
          this.feedbackSummary.total = data?.total_data_elements ?? 0;
          this.feedbackSummary.positive = data?.total_positives ?? 0;
          this.feedbackSummary.reviewed = data?.reviewed ?? data?.user_review_count ?? 0;
        }
        this.feedbackSummaryLoading = false;
      });
    } catch (e) {
      // ignore subscription setup errors
    }
  }

  markUpdate(element: any) {
    const level = element.level;
    let updatedElement = {
      data_element: element.data_element_name,
      updated_value: element.ai_answer,
      feedback: element.feedback,
      _level: level // internal only; will be removed before API call
    } as any;

    let index = this.updatedElements.findIndex(
      (item) => item.data_element === updatedElement.data_element
    );
    if (index > -1) {
      this.updatedElements.splice(index, 1);
    }
    this.updatedElements.push(updatedElement);
    this.isDataChanged = true;
    try {
      const isL0 = level === 0 || level === '0' || String(level) === '0';
      if (isL0) {
        element.is_updated_value = true;
        element.is_updated_results = false;
      }
    } catch (e) {
      // ignore
    }
  }
  isL2NarrativeWithAttachment(row: any): boolean {
    if (!row || row.level !== 2 || !row.traces || !Array.isArray(row.traces)) return false;
  return row.traces.some((t: any) => t.contentDispositionType === 'attachment');
  }
  removeHtmlTags(html: string): string {
    return html.replace(/<[^>]*>/g, '');
  }
  isPdfItem(item: any): boolean {
    if (!item) return false;
    try {
      const fileType = (item.fileType || '').toString().toLowerCase();
      const filename = (item.original_filename || item.file_name || item.name || '').toString().toLowerCase();
      return fileType === 'pdf' || filename.endsWith('.pdf');
    } catch (e) {
      return false;
    }
  }
  isLevel2(element: any): boolean {
    if (!element) return false;
    const level = element.level;
    return level === 2 || level === '2' || String(level) === '2';
  }
  showSourceDoc(chunk: any) {
    this.selectedChunk = chunk;
    if (chunk && (chunk.original_filename?.toLowerCase().endsWith('.pdf') || chunk.file_name?.toLowerCase().endsWith('.pdf') || chunk.name?.toLowerCase().endsWith('.pdf'))) {
      this.selectedDocumentIndex = -1;
      this.selectedDocumentId = chunk.doc_id || chunk.id || null;
    }
    const prevTabSelected = Array.isArray(this.motifTabSelected) ? [...this.motifTabSelected] : this.motifTabSelected;
    const prevLevelSelected = Array.isArray(this.motifLevelSelected) ? [...this.motifLevelSelected] : this.motifLevelSelected;
    // clear existing PDF display and show loading indicator
    this.isPdfLoading = true;
    this.showNoDocument = false;
    this.pageNumber = 1;
    this.setPdfViewerSrc(null);
    if (chunk && chunk.page_number !== undefined) {
      this.pageNumber = chunk.page_number;
    }
    const filenameGuess = chunk.original_filename ? chunk.original_filename.toLowerCase() : '';
    this.isCurrentPdf = filenameGuess.endsWith('.pdf');
    if (this.isCurrentPdf && this.resultBox && this.resultBox.nativeElement) {
      setTimeout(() => {
        this.resultBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    }
    // Capture currently expanded dependents so we can restore them after reload
    const preserveDependentState: { [name: string]: boolean } = {};
    if (Array.isArray(this.tableData)) {
      this.tableData.forEach((row: any) => {
        if (row && row.data_element_name) {
          preserveDependentState[row.data_element_name] = !!row.dependentExpanded;
        }
      });
    }

    this.mappingResultService.getSourceDoc(chunk.doc_id).subscribe({
      next: (resp: any) => {
        const contentDisposition = resp.headers?.get?.('content-disposition') || resp.headers?.get?.('Content-Disposition') || '';
        const blob: Blob = resp.body as Blob;
        const filename = this.extractFileName(contentDisposition) || chunk.original_filename;
        const isPdf = (blob.type === 'application/pdf') || filename.toLowerCase().endsWith('.pdf');
        this.isCurrentPdf = isPdf;
        // Block non-PDF documents for Level 2 attributes
        if (chunk.level === 2 && !isPdf) {
          this.showNoDocument = true;
          this.isCurrentPdf = false;
          this.isPdfLoading = false;
          this._snackBar.open('Document preview is not available for Level 2 narrative non-PDF files.', 'ok', { duration: 2000 });
          return;
        }
        if (this.shouldPreview(filename, blob.type, isPdf)) {
          try { if (this.currentPdfObjectUrl) { window.URL.revokeObjectURL(this.currentPdfObjectUrl); } } catch (e) {}
          try { this.currentPdfObjectUrl = null; } catch (e) {}
          try {
            const url = window.URL.createObjectURL(blob);
            this.currentPdfObjectUrl = url;
            this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
          } catch (e) {
            console.error('Failed to create object URL for source doc', e);
          }
        } else {
          this.showNoDocument = true;
          this.isCurrentPdf = false;
          this.cdr.detectChanges();
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(downloadUrl);
        }
        this.isPdfLoading = false;
      },
      error: (err: any) => {
        console.error('Failed to load document', err);
        this.isPdfLoading = false;
      },
      complete: () => {
        this.getMappingResultWithRestore(prevTabSelected, prevLevelSelected, preserveDependentState);
      },
    });
  }

  private extractFileName(contentDisposition: string): string | null {
    if (!contentDisposition) return null;
    const filenameRegex = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i;
    const match = filenameRegex.exec(contentDisposition);
    if (match) {
      return decodeURIComponent(match[1] || match[2]);
    }
    return null;
  }
  
  groupDocumentsByClassification() {
    const groups: { [classification: string]: any[] } = {};
    for (const doc of this.documentList) {
      const classification = doc.doc_classification || 'Unclassified';
      if (!groups[classification]) {
        groups[classification] = [];
      }
      groups[classification].push(doc);
    }
    this.classifiedDocuments = groups;
    this.classifiedGroupKeys = Object.keys(groups);
    this.currentGroupIndex = 0;
  }

  navigateGroup(direction: number) {
    const newIndex = this.currentGroupIndex + direction;
    if (newIndex >= 0 && newIndex < this.classifiedGroupKeys.length) {
      this.currentGroupIndex = newIndex;
    }
  }

  toggleClassificationAccordion(classification: string) {
    Object.keys(this.expandedClassifications).forEach(key => {
      this.expandedClassifications[key] = false;
    });
    this.expandedClassifications[classification] = true;
  }

  selectDocumentById(docId: string) {
    const idx = this.documentList.findIndex(d => d.id === docId || d.doc_id === docId);
    if (idx !== -1) {
      const doc = this.documentList[idx];
      this.selectedDocumentIndex = idx;
      this.selectedDocumentId = docId;
      // Determine if PDF
      const filename = doc.original_filename || doc.file_name || doc.name || '';
      const isPdf = filename && typeof filename === 'string' ? filename.toLowerCase().endsWith('.pdf') : false;
      if (isPdf) {
        this.showNoDocument = false;
        // Scroll resultBox into view immediately on click
        if (this.resultBox && this.resultBox.nativeElement) {
          setTimeout(() => {
            this.resultBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 0);
        }
        this.selectDocument(idx);
      } else {
        // Download non-PDF document
        this.downloadDocument(doc);
      }
    }
  }

  downloadDocument(doc: any) {
    if (!doc || !doc.doc_id) return;
    this.mappingResultService.getSourceDoc(doc.doc_id).subscribe({
      next: (resp: any) => {
        const contentDisposition = resp.headers?.get?.('content-disposition') || resp.headers?.get?.('Content-Disposition') || '';
        const blob: Blob = resp.body as Blob;
        const filename = this.extractFileName(contentDisposition) || doc.original_filename || doc.file_name || doc.name || 'Document';
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
      },
      error: (err: any) => {
        console.error('Failed to download document', err);
      }
    });
  }

  fetchDocumentList() {
    if (!this.doc_run_id) return;
    this.showDocumentListLoading = true;
    this.service.getDocRunInfo(this.doc_run_id, this.year, this.quarter).subscribe({
      next: (docs: any[]) => {
  this.documentList = docs || [];
  this.showDocumentListLoading = false;
  this.groupDocumentsByClassification();
      },
      error: () => {
  this.documentList = [];
  this.showDocumentListLoading = false;
  this.groupDocumentsByClassification();
      }
    });
  }

  selectDocument(index: number) {
    this.selectedDocumentIndex = index;
    const doc = this.documentList[index];
    if (doc) {
      this.showSourceDoc({
        file_location: doc.file_location || doc.file_url,
        bounding_box: null,
        page_number: 1,
        doc_id: doc.doc_id
      });
    }
  }

  scrollDocumentList(direction: 'prev' | 'next') {
    if (direction === 'prev' && this.selectedDocumentIndex > 0) {
      this.selectDocument(this.selectedDocumentIndex - 1);
    } else if (direction === 'next' && this.selectedDocumentIndex < this.documentList.length - 1) {
      this.selectDocument(this.selectedDocumentIndex + 1);
    }
  }

  private shouldPreview(filename: string | undefined | null, mime: string, isPdf: boolean): boolean {
    if (mime === 'application/pdf' || isPdf) {
      if (filename) {
        const lower = filename.toLowerCase();
        const officeExts = ['.doc', '.docx', '.xlsx', '.ppt', '.pptx'];
        if (officeExts.some(ext => lower.endsWith(ext))) return false;
      }
      return true;
    }
    return false;
  }
  getMappingResultWithRestore(prevTabSelected: any, prevLevelSelected: any, preserveDependentState?: { [name: string]: boolean }) {
    this.mappingResultService
      .getMappingResult(this.doc_run_id, this.doc_req_id)
      .subscribe((data) => {
        this.extraction_run_id = data?.extraction_run_id;
        data.run_results.forEach((element: any) => {
          element.feedback = '';
          element.feedbacks = element.audit_log.filter((log: any) => log.feedback !== '');
          element.dependentExpanded = false;
          element.is_updated_value = element.is_updated_value === true;
          element.is_updated_results = element.is_updated_results === true;
          // Persist last negative category for UI coloring after refresh (no local storage)
          try {
            if (element.confidence_level_validation === false) {
              let category = element.category_name || '';
              if (!category && Array.isArray(element.audit_log)) {
                const catLog = [...element.audit_log].reverse().find((log: any) => !!log?.category_name);
                category = catLog?.category_name || '';
              }
              element.category_name = category;
            } else {
              element.category_name = '';
            }
          } catch {}
        });
        this.tableData = data.run_results;
        this.dataSource = new MatTableDataSource(data.run_results);
        let tabSet = new Set<string>();
        data.run_results.forEach((obj: any) => {
          if (obj.tab_name) {
            obj.tab_name
              .split(/[;]+/)
              .map((t: string) => {
                let trimmed = t.trim();
                if (/and/.test(trimmed) && /\.$/.test(trimmed)) {
                  trimmed = trimmed + ',';
                }
                return trimmed;
              })
              .forEach((t: string) => {
                if (t) tabSet.add(t);
              });
          }
        });
        const tabs = Array.from(tabSet);
        this.allTabs = [...tabs];
        const fixedTabOrder = [
        'Relationship Overview',
        'Repayment Analysis',
        'Covenant Analysis',
        'Collateral Analysis',
        'Regulatory Rating'
        ];
        // Compute available tabs from data; if none found (e.g., empty results),
        // preserve previous options or fall back to the fixed order to keep the tab bar visible.
        let nextTabOptions = fixedTabOrder.filter(tab => tabs.includes(tab));
        if (nextTabOptions.length === 0) {
          nextTabOptions = (this.motifTabOptions && this.motifTabOptions.length > 0)
            ? this.motifTabOptions
            : fixedTabOrder;
        }
        // Ensure tab options always follow the fixedTabOrder sequence
        this.motifTabOptions = nextTabOptions.sort((a: string, b: string) => {
          const ia = fixedTabOrder.indexOf(a);
          const ib = fixedTabOrder.indexOf(b);
          const pa = ia === -1 ? Number.MAX_SAFE_INTEGER : ia;
          const pb = ib === -1 ? Number.MAX_SAFE_INTEGER : ib;
          return pa - pb;
        });
        this.motifLevelOptions = [
          { value: '0', label: 'Level 0' },
          { value: '1', label: 'Non Narrative' },
          { value: '2', label: 'Narrative' },
        ];
        // Restore previous selections and ensure a valid tab remains selected/displayed
        this.motifTabSelected = prevTabSelected;
        this.motifLevelSelected = prevLevelSelected;
        const selectedArray = Array.isArray(this.motifTabSelected)
          ? this.motifTabSelected
          : (this.motifTabSelected ? [this.motifTabSelected] : []);
        const hasValidSelection = selectedArray.some(t => this.motifTabOptions.includes(t));
        if (!hasValidSelection) {
          this.motifTabSelected = this.motifTabOptions && this.motifTabOptions.length > 0
            ? [this.motifTabOptions[0]]
            : [];
        }
        this.filterDataSourceMotif();
        if (preserveDependentState && typeof preserveDependentState === 'object') {
          Object.keys(preserveDependentState).forEach((name) => {
            if (preserveDependentState[name]) {
              const row = this.tableData?.find((r: any) => r.data_element_name === name);
              if (row) {
                row.dependentExpanded = false;
                const section = this.findSectionForElement(row) || undefined;
                try {
                  this.toggleDependents(row, section);
                } catch (e) {
                }
              }
            }
          });
          this.cdr.detectChanges();
        }
        this.isUpdateResultsEnabled = this.shouldEnableUpdateResults(this.tableData);
      });
  }
  private shouldEnableUpdateResults(runResults: any[] | undefined): boolean {
  if (!runResults || !Array.isArray(runResults) || runResults.length === 0) return false;
    for (const el of runResults) {
      const level = el?.level;
      const isL0 = level === 0 || level === '0' || String(level) === '0';
      const isUpdatedValue = el?.is_updated_value === true;
      const isUpdatedResults = el?.is_updated_results === true;
      if (isL0 && isUpdatedValue && !isUpdatedResults) {
        return true;
      }
    }
    return false;
  }

  onDocumentLoaded() {
    this.isPdfLoading = false;
    try {
      if (this.viewerSettingTimeoutId) {
        try { clearTimeout(this.viewerSettingTimeoutId); } catch (e) {}
        this.viewerSettingTimeoutId = null;
      }
    } catch (e) {}
  }

  openHistoryModal(element: any) {
  this.mappingResultService.getHistoryAndComments({
    doc_run_id: this.doc_run_id,
    request_id: this.doc_req_id,
    data_element_name: element.data_element_name
  }).subscribe({
    next: (res: any) => {
      let history: Array<{ previous_value: string; updated_value: string; updated_at: string; updated_by: string; previous_confidence?: boolean; updated_confidence?: boolean; category_name?: string }> = [];
      if (res && Array.isArray(res.history)) {
        history = res.history.map((log: any) => ({
          previous_value: log.previous_value || '',
          updated_value: log.updated_value || '',
          updated_at: log.updated_at || '',
          updated_by: log.updated_by || '',
          previous_confidence: log.previous_confidence,
          updated_confidence: log.updated_confidence,
          category_name: log.category_name
        })).reverse();
      }
      this.dialog.open(MappingResultHistoryModalComponent, {
        width: '800px',
        maxWidth: '95vw',
        height: '80vh',
        maxHeight: '80vh',
        data: { attributeName: element.data_element_name, history }
      });
    },
    error: () => {
      this.dialog.open(MappingResultHistoryModalComponent, {
        width: '800px',
        maxWidth: '95vw',
        height: '80vh',
        maxHeight: '80vh',
        data: { attributeName: element.data_element_name, history: [] }
      });
    }
  });
}


  openFeedbackDialog(element: any): boolean {
    this.dialog.open(MappingResultFeedbackComponent, {
      width: '250px',
      disableClose: true,
      data: { data: element.feedbacks },
    });
    return false;
  }

    onUpdateValidation(element: any, newValue: boolean) {
      if (element.confidence_level_validation === newValue) {
        return;
      }
      const dialogRef = this.dialog.open(ConfirmStatusDialogComponent, {
        width: '350px',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          const userEmail = this.profileService.getUserEmail();
          const payload = {
            doc_run_id: this.doc_run_id,
            request_id: this.doc_req_id,
            data_element_name: element.data_element_name,
            updated_confidence_validation: newValue,
            previous_confidence_validation: element.confidence_level_validation === null ? null : !!element.confidence_level_validation,
            updated_by: userEmail,
            ai_answer: element.ai_answer || '',
            ...(newValue === true ? { category_name: '' } : {})
          };
          this.mappingResultService.updateAttributeValidation(payload).subscribe({
            next: () => {
              // update local state
              element.confidence_level_validation = newValue;
              if (!element.reviewed) {
                element.reviewed = true;
                // optimistic update of counts
                this.feedbackSummary.reviewed = (this.feedbackSummary.reviewed || 0) + 1;
                if (newValue === true) {
                  this.feedbackSummary.positive = (this.feedbackSummary.positive || 0) + 1;
                }
                this.cdr.detectChanges();
              }
              if (newValue === false) {
                this.openFeedbackCategoryModal(element);
              }
              if (this.doc_req_id && this.doc_run_id) {
                this.mappingResultService.getFeedbackSummaryRequest(this.doc_req_id, this.doc_run_id).subscribe({
                  next: (data) => {
                    this.feedbackSummary.total = data?.total_data_elements ?? 0;
                    this.feedbackSummary.positive = data?.total_positives ?? 0;
                    this.feedbackSummary.reviewed = data?.reviewed ?? data?.user_review_count ?? 0;
                  },
                  error: () => {
                    // ignore and keep optimistic values
                  }
                });
              }
            },
            error: () => {
              this._snackBar.open('Failed to update validation', 'ok', { duration: 2000 });
            }
          });
        }
      });
    }

  openConfirmValidationDialog() {
    let confirmation = this.dialog.open(ConfirmationValidationComponent, {
      width: '350px',
      disableClose: true,
    });
    confirmation.afterClosed().subscribe((result) => {
      this.isConfirmValidation = result;
      if (this.isConfirmValidation) {
        this.isEditMode = false;
        let updateData = {
          doc_run_id: this.doc_run_id,
          request_id: this.doc_req_id,
          timestamp: Date.now().toString(),
          updated_by: 'ui',
          attributes: this.updatedElements,
        };

        this.mappingResultService.bulkUpdate(updateData).subscribe({
          next: (response: any) => {
            this._snackBar.open(response.message, 'ok', { duration: 2000 });
            this.getMappingResult();

            // Enable Update Results only when Level 0 attributes were saved.
            const savedL0Exists = Array.isArray(updateData.attributes) && updateData.attributes.some((a: any) => a && a.is_updated_value === true);
            this.isUpdateResultsEnabled = !!savedL0Exists;
          },
          error: (error) => {
          console.error('Error loading PDF:', error);
          try {
            this._snackBar.open((error && error?.message) ? error.message : 'Failed to save changes', 'ok', { duration: 4000 });
          } catch (e) {
            //ignore
          }
        },
          complete: () => {
            // Optional: handle completion
          },
        });
      }
    });
  }
  private originalValuesSnapshot: { [key: string]: any } = {};

  bulkUpdateTable() {
    if (this.updatedElements?.length) {
      this.isEditMode = false;
      const collectDependentUpdates = () => {
        let dependents: any[] = [];
        this.updatedElements.forEach((el) => {
          if (el.dependentAttributesResults && Array.isArray(el.dependentAttributesResults)) {
            el.dependentAttributesResults.forEach((dep: any) => {
              if (dep._isChanged) {
                let previousValue = '';
                if (this.originalValuesSnapshot && this.originalValuesSnapshot[dep.data_element_name] !== undefined) {
                  previousValue = this.originalValuesSnapshot[dep.data_element_name];
                } else {
                  const original = this.tableData?.find((row: any) => row.data_element_name === dep.data_element_name);
                  previousValue = original ? original.ai_answer : '';
                }
                dependents.push({
                  data_element: dep.data_element_name,
                  updated_value: dep.ai_answer,
                  feedback: dep.feedback,
                  previous_value: previousValue
                });
              }
            });
          }
        });
        return dependents;
      };

      const attributesWithPrevious = this.updatedElements.map((el) => {
        let previousValue = '';
        if (this.originalValuesSnapshot && this.originalValuesSnapshot[el.data_element] !== undefined) {
          previousValue = this.originalValuesSnapshot[el.data_element];
        } else {
          const original = this.tableData?.find((row: any) => row.data_element_name === el.data_element);
          previousValue = original ? original.ai_answer : '';
        }
        const originalRow = this.tableData?.find((row: any) => row.data_element_name === el.data_element);
        const level = el._level !== undefined ? el._level : originalRow?.level;
        const isChanged = previousValue !== el.updated_value;
        if ((level === '0' || level === 0) && isChanged) {
          return {
            data_element: el.data_element,
            updated_value: el.updated_value,
            feedback: el.feedback,
            previous_value: previousValue,
            is_updated_value: true,
            is_updated_results: false
          };
        } else {
          return {
            data_element: el.data_element,
            updated_value: el.updated_value,
            feedback: el.feedback,
            previous_value: previousValue
          };
        }
      });

      // Add dependents
      const dependentUpdates = collectDependentUpdates();
      const allUpdates = [...attributesWithPrevious, ...dependentUpdates];

      // Propagate dependent changes everywhere in tableData
      dependentUpdates.forEach(dep => {
        if (this.tableData && Array.isArray(this.tableData)) {
          this.tableData.forEach((row: any) => {
            if (row.data_element_name === dep.data_element) {
              row.ai_answer = dep.updated_value;
              row.feedback = dep.feedback;
            }
            // Also update in dependentAttributesResults if present
            if (row.dependentAttributesResults && Array.isArray(row.dependentAttributesResults)) {
              row.dependentAttributesResults.forEach((d: any) => {
                if (d.data_element_name === dep.data_element) {
                  d.ai_answer = dep.updated_value;
                  d.feedback = dep.feedback;
                }
              });
            }
          });
        }
      });

      let updateData = {
        doc_run_id: this.doc_run_id,
        request_id: this.doc_req_id,
        updated_by: this.profileService.getUserEmail(),
        attributes: allUpdates,
      };

      this.mappingResultService.bulkUpdate(updateData).subscribe({
        next: (response: any) => {
          this._snackBar.open(response.message, 'ok', { duration: 2000 });

          // Refresh mapping results
          this.getMappingResult();

          // Determine if any Level 0 attributes were saved (they should have
          // is_updated_value === true). Only in that case enable Update Results
          // so the user can trigger re-run.
          const savedL0Exists = Array.isArray(updateData.attributes) && updateData.attributes.some((a: any) => a && a.is_updated_value === true);

          // Clear local buffers
          this.updatedElements = [];
          this.originalValuesSnapshot = {};

          // Enable Update Results only when L0 changes were saved
          this.isUpdateResultsEnabled = !!savedL0Exists;
        },
        error: (error) => {
          console.error('Error loading PDF:', error);
          try {
            this._snackBar.open((error && error?.message) ? error.message : 'Failed to save changes', 'ok', { duration: 4000 });
          } catch (e) {
            // ignore
          }
        },
        complete: () => {
          // Optional: handle completion
        },
      });
    } else {
      this._snackBar.open('Please make changes', '', { duration: 2000 });
    }
  }

  openAiInsightDialog(element: any, section?: string): boolean {
    // For Regulatory Rating, instruct the AI Insights modal to show only the rationale/summary section
    const showOnly = this.isRegulatory(section) ? 'rationale' : undefined;
    this.dialog.open(AiInsightsComponent, {
      width: '450px',
      height: '90vh',
      position: { top: '10px', right: '0' },
      disableClose: true,
      data: { data: element, showOnly },
    });
    return false;
  }

  hasDependents(element: any): boolean {
    if (!element) return false;
    const deps = element.dependent_attributes;
    if (!deps) return false;
    if (Array.isArray(deps)) return deps.length > 0;
    if (typeof deps === 'object') return Object.keys(deps).length > 0;
    return false;
  }
  toggleDependents(element: any, section?: string) {
    element.dependentExpanded = !element.dependentExpanded;
    const sectionKey = section || this.findSectionForElement(element);
    if (!sectionKey || !this.sectionDataSources[sectionKey]) return;
    const dataSource = this.sectionDataSources[sectionKey];
    const currentData = dataSource.data;
    const parentIndex = currentData.indexOf(element);
    if (parentIndex === -1) return;

    if (element.dependentExpanded) {
      if (!element.dependentAttributesResults) {
        const payload = {
          doc_run_id: this.doc_run_id,
          request_id: this.doc_req_id,
          attributes: element.dependent_attributes || []
        };
        this.mappingResultService.getDependentAttributesResult(payload).subscribe({
          next: (res: any) => {
            let results: any[] = [];
            if (Array.isArray(res)) {
              results = res;
            } else if (res && Array.isArray(res.results)) {
              results = res.results;
            } else if (res && Array.isArray(res.dependent_attributes)) {
              results = res.dependent_attributes;
            }
            // Mark each dependent row
            results = results.map(r => ({ ...r, isDependent: true, parentId: element.data_element_name }));
            element.dependentAttributesResults = results;
            // Inject after parent row
            const newData = [
              ...currentData.slice(0, parentIndex + 1),
              ...results,
              ...currentData.slice(parentIndex + 1)
            ];
            dataSource.data = newData;
            this.cdr.detectChanges();
          },
          error: () => {
            element.dependentAttributesResults = [];
            this.cdr.detectChanges();
          }
        });
      } else {
  const results = (element.dependentAttributesResults || []).map((r: any) => ({ ...r, isDependent: true, parentId: element.data_element_name }));
        const newData = [
          ...currentData.slice(0, parentIndex + 1),
          ...results,
          ...currentData.slice(parentIndex + 1)
        ];
        dataSource.data = newData;
        this.cdr.detectChanges();
      }
    } else {
      // Collapse: remove dependent rows
      dataSource.data = currentData.filter((r: any) => r === element || r.parentId !== element.data_element_name);
      this.cdr.detectChanges();
    }
  }

  private findSectionForElement(element: any): string | null {
    if (!element) return null;
    for (const sec of this.sectionOrder) {
      const ds = this.sectionDataSources[sec];
      if (ds && ds.data.includes(element)) return sec;
    }
    return null;
  }
  getDependentList(element: any): string[] {
    if (!element || !element.dependent_attributes) return [];
    const deps = element.dependent_attributes;
    if (Array.isArray(deps)) {
      // array may be strings or objects; normalize to string names
      return deps.map((d: any) => {
        if (typeof d === 'string') return d;
        return d?.data_element_name || d?.attribute_name || JSON.stringify(d);
      });
    }
    if (typeof deps === 'object') {
      // object could be a map of name->value
      return Object.keys(deps);
    }
    return [];
  }

  onToggleEditMode(event: any) {
    this.isEditMode = event.checked;
    if (event.checked) {
      // edit mode on
      this.isConfirmValidation = false;
      // snapshot original values for all data elements
      this.originalValuesSnapshot = {};
      if (Array.isArray(this.tableData)) {
        this.tableData.forEach((row: any) => {
          this.originalValuesSnapshot[row.data_element_name] = row.ai_answer;
        });
      }
    } else {
      this.getMappingResult();
    }
  }

  onCancelEdit(): void {
    this.isEditMode = false;
    if (this.originalValuesSnapshot && this.tableData && Array.isArray(this.tableData)) {
      this.tableData.forEach((row: any) => {
        const original = this.originalValuesSnapshot[row.data_element_name];
        if (original !== undefined) {
          row.ai_answer = original;
          row.is_updated_value = row.is_updated_value === true ? false : row.is_updated_value;
        }
        if (row.dependentAttributesResults && Array.isArray(row.dependentAttributesResults)) {
          row.dependentAttributesResults.forEach((d: any) => {
            const origDep = this.originalValuesSnapshot[d.data_element_name];
            if (origDep !== undefined) {
              d.ai_answer = origDep;
            }
            if (d._isChanged) delete d._isChanged;
          });
        }
      });
    }

    // clear temporary buffers
    this.updatedElements = [];
    this.originalValuesSnapshot = {};
    try {
      this.getMappingResult();
    } catch (e) {
      // fallback: ensure dataSource reflects tableData
      this.dataSource = new MatTableDataSource(this.tableData || []);
    }
  }

  onToggleConfirmValidation(event: any) {
    this.isConfirmValidation = event.checked;
    if (event.checked) {
      // confirm validation on
      let isValid = this.openConfirmValidationDialog();
    } else {
      // confirm validation off
    }
  }
  generateResult() {
    // Open generate modal without preselecting a tab
    this.selectedTabName = '';
    this.isModalOpen = true;
  }

  // Called when the generate report modal select changes
  onGenerateTabChange(tabName: string) {
    // Load attributes for the selected tab (or ALL)
    if (!tabName) return;
    // If user selected 'All' we request ALL mapping
    const normalized = tabName === 'All' ? 'ALL' : tabName;
    this.loadReadonlyAttributes(normalized);
  }

  filterDataSource() {
    let tab = this.tabFilter?.value;
    // console.log('tab', tab);
    let level = this.levelFilter?.value;
    this.tabName = tab;
    // console.log('tabName', this.tabName);
    // console.log('level', level);

    if (tab === undefined || tab === null || tab === '') {
      tab = 'All Tabs';
    }

    if (level === undefined || level === null || level === '') {
      level = 'All';
    }

    if (tab === 'All Tabs' && level === 'All') {
      this.dataSource = new MatTableDataSource(this.tableData);
    } else if (tab !== 'All Tabs' && level === 'All') {
      this.dataSource = new MatTableDataSource(
        this.tableData.filter((d: any) => d.tab_name === tab)
      );
    } else if (tab === 'All Tabs' && level !== 'All') {
      this.dataSource = new MatTableDataSource(
        this.tableData.filter(
          (d: any) => d.level && d.level.toString() === level
        )
      );
    } else {
      this.dataSource = new MatTableDataSource(
        this.tableData.filter(
          (d: any) =>
            d.tab_name === tab && d.level && d.level.toString() === level
        )
      );
    }
  }
  ApplyLevelFilter(value: any) {
    if (value === 'All Tabs') {
      this.dataSource = JSON.parse(JSON.stringify(this.tableData));
    } else {
      let tempData = this.tableData.filter((e: any) => e.level === value);
      this.dataSource = JSON.parse(JSON.stringify(tempData));
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file && file.name.toLowerCase().endsWith('.docx')) {
      this.selectedFile = file;
    } else {
      this.selectedFile = null;
      this._snackBar.open('Only .docx files are allowed', 'ok', {
        duration: 2000,
      });
      (event.target as HTMLInputElement).value = '';
    }
  }
  onUpload(): void {
    if (this.selectedFile) {
      //      console.log('Selected file:', this.selectedFile);
      this.IsLoader = true;
      const formData = new FormData();
      formData.append('document', this.selectedFile, this.selectedFile.name);
      formData.append('request_id', this.doc_req_id);
      formData.append('extraction_run_id', this.extraction_run_id);
      formData.append('sub_product', this.sub_product);
      formData.append('tab_name', this.tabName || 'default');
      // Call a service method to send formData to the backend
      this.mappingResultService.uploadDocument(formData).subscribe({
        next: (response: any) => {
          this.IsLoader = false;
          if (!!response.file_info?.base64_content) {
            const { base64_content, content_type, filename } =
              response.file_info;
            const blob = base64ToBlob(base64_content, content_type);
            this.downloadFile(blob, filename);
            this._snackBar.open(
              'File uploaded and downloaded successfully',
              'ok',
              { duration: 2000 }
            );
          } else {
            this._snackBar.open(
              response.message || 'File uploaded successfully',
              'ok',
              { duration: 2000 }
            );
          }
          // Reset the file input element if it exists
          this.reSetFileInput();
        },
        error: (error) => {
          this.IsLoader = false;
          console.error('Error uploading document:', error);
          this._snackBar.open('Failed to upload document', 'ok', {
            duration: 2000,
          });
          this.reSetFileInput();
        },
      });
    }
  }

  /* function to download file */
  downloadFile(file: Blob, filename: string): void {
    const url = URL.createObjectURL(file);
    const a = Object.assign(document.createElement('a'), {
      href: url,
      download: filename || this.selectedFile?.name,
    });
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    this.selectedFile = null;
  }

  /* Reset the file on api success or failure and close modal */
  reSetFileInput(): void {
    this.selectedFile = null;
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.isUploadModalOpen = false;
  }

  fetchCommentCounts() {
    if (this.doc_run_id) {
      this.mappingResultService.getCommentsCount(this.doc_run_id).subscribe({
        next: (counts) => {
          this.commentCounts = counts || {};
        },
        error: () => {
          this.commentCounts = {};
        }
      });
    }
  }
  onUpdateResults() {
    if (!this.isUpdateResultsEnabled || this.isUpdatingResults) return;
    const dataElements: string[] = [];
    if (Array.isArray(this.tableData)) {
      this.tableData.forEach((row: any) => {
        const isL0 = row.level === 0 || row.level === '0' || String(row.level) === '0';
        const isUpdatedValue = row.is_updated_value === true;
        const isUpdatedResults = row.is_updated_results === true;
        if (isL0 && isUpdatedValue && !isUpdatedResults) {
          const name = row.data_element_name || row.data_element || row.attribute_name;
          if (name) dataElements.push(name);
        }
      });
    }

    if (!dataElements.length) {
      this._snackBar.open('No Level 0 elements marked for re-run', 'ok', { duration: 2000 });
      return;
    }

    const payload = {
      request_id: this.doc_req_id,
      doc_run_id: this.doc_run_id,
      extraction_run_id: this.extraction_run_id,
      data_elements: dataElements,
    };

    // mark updating and disable the Update Results button immediately
    this.isUpdatingResults = true;
    this.isUpdateResultsEnabled = false;
    // poll feedback summary every 5s while re-run is active so counts update
    try {
      if (!this.feedbackSummaryPollId) {
        this.feedbackSummaryPollId = setInterval(() => { try { this.getFeedbackSummary(); } catch(e) {} }, 5000);
      }
    } catch (e) {}

    this.mappingResultService.updateReRunResults(payload).subscribe({
      next: (res: any) => {
        this._snackBar.open(res?.message || 'Update started', 'ok', { duration: 2000 });
        // Immediately reflect that an update/rerun was started
        this.extractionStatus = 'IN_PROGRESS';
        this.cdr.detectChanges();

        // After triggering rerun, refresh mapping results in background
        this.getMappingResult();
        // Optionally clear updatedElements list (we reloaded data anyway)
        this.updatedElements = [];
      },
      error: (err: any) => {
        console.error('Failed to update results', err);
        this._snackBar.open('Failed to update results', 'ok', { duration: 2000 });
        // stop polling on error
        try { if (this.feedbackSummaryPollId) { clearInterval(this.feedbackSummaryPollId); this.feedbackSummaryPollId = null; } } catch (e) {}
        this.isUpdatingResults = false;
      }
      // Note: do not clear isUpdatingResults here — wait for requestIdUpdates/extractionCompleted
    });
  }

  ngOnDestroy(): void {
    try {
      this.componentSubscriptions.unsubscribe();
    } catch (e) {}
    try {
      if (this.feedbackSummarySub) {
        this.feedbackSummarySub.unsubscribe();
        this.feedbackSummarySub = null;
      }
    } catch (e) {}
    try {
      if (this.feedbackSummaryPollId) {
        clearInterval(this.feedbackSummaryPollId);
        this.feedbackSummaryPollId = null;
      }
    } catch (e) {}
    try {
      if (this.currentPdfObjectUrl) {
        try { window.URL.revokeObjectURL(this.currentPdfObjectUrl); } catch (e) {}
        this.currentPdfObjectUrl = null;
      }
    } catch (e) {}
    try {
      if (this.viewerSettingTimeoutId) {
        try { clearTimeout(this.viewerSettingTimeoutId); } catch (e) {}
        this.viewerSettingTimeoutId = null;
      }
    } catch (e) {}
    try { this.pendingPdfBlob = null; } catch (e) {}
    this.dialog.closeAll();
  }
}
